import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { Modal, Icon } from 'semantic-ui-react';

import { setYesNoDialogProps } from 'Components/dialogs/state/actions';
import { EditIngredient } from 'Pages/manageingredient/subpages/editingredient/EditIngredient';
import * as EditIngActions from 'Pages/manageingredient/state/editingredient/actions';
import * as EditIngSelectors from 'Pages/manageingredient/state/editingredient/selectors';

class IngredientModal extends Component {
  static propTypes = {
    onSaveClose: PropTypes.func.isRequired,
    modalProps: PropTypes.shape({
      open: PropTypes.bool.isRequired,
      onClose: PropTypes.func.isRequired,
      size: PropTypes.string,
    }),
  };

  handleOnClose = () => {
    const { modalProps, isDirty, setYesNoDialogProps } = this.props;
    const { onClose } = modalProps;
    if (isDirty) {
      setYesNoDialogProps({
        showDialog: true,
        isSavePrompt: true,
        yesCallback: () => onClose(),
        noCallback: () => {},
      });
    } else {
      onClose();
    }
  };

  componentDidUpdate(prevProps) {
    const { saveSuccessful: saveSuccessfulPrev } = prevProps;
    const { isValid, saveSuccessful, onSaveClose } = this.props;
    if (saveSuccessfulPrev !== saveSuccessful && isValid) {
      onSaveClose();
    }
  }

  render() {
    const { modalProps } = this.props;

    return (
      <Modal {...modalProps} className="recipe-modal-container">
        <Modal.Header>
          <Icon name="close" onClick={this.handleOnClose} />
        </Modal.Header>

        <Modal.Content scrolling>
          <EditIngredient openedInModal={true} />
        </Modal.Content>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isDirty: EditIngSelectors.isDirtySelector(state),
    isValid: EditIngSelectors.isValidSelector(state),
    saveSuccessful: EditIngSelectors.getSaveSuccessful(state),
  };
};

const mapDispatchToProps = {
  submitIngredientForm: EditIngActions.submitIngredientForm,
  setYesNoDialogProps,
};

IngredientModal = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(IngredientModal)
);

export { IngredientModal };



// WEBPACK FOOTER //
// ./src/pages/manageingredient/subpages/editingredient/components/IngredientModal.js